var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotovoltaics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 58,
    viewBox: "0 0 63 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.487 6.68c-.03 1.116-1.188 1.74-1.846 1.541-.84-.257-3.071-3.445-2.783-4.363.85-2.727 3.852.706 4.629 2.821zM1.847 13.634c.54-.505 3.558.11 4.31 1.098.62.813.555 1.731-.237 2.142-.36.19-3.07-.417-3.784-1.068-.89-.814-.918-1.582-.29-2.172zM20.264.951c.637-.86 1.693-.579 2.285.62.353.715.213 3.46-.26 3.937-.733.74-1.882.34-2.337-.84-.385-1.002.306-2.862.312-3.717zM27.767 12.55c-.43.62-1.38.949-2.01 1.393-2.828-3.67-6.719-4.962-10.54-2.864-4.827 2.648-5.587 7.788-2.658 11.897-.487.504-1.302 1.303-2.038 1.533C7.074 19.971 7.597 14 11.806 10.451c5.579-4.7 12.255-3.424 15.961 2.098zM8.385 25.974c-.892.783-2.354 1.967-3.385 2.103-.908-.304-1.693-1.179-1.082-2.195.668-1.108 3.016-2.271 3.632-1.905.59.35.995 1.319.835 1.997zM29.494 9.281c1.06-1.124 3.26-2.85 4.03-.525.485 1.468-3.922 4.35-4.602 1.759-.132-.501.063-.694.572-1.234z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m55.968 19.675 2.982 27.84H16.14l3.314-27.84h36.514zm1.379-3.089H18.089c-.864 0-1.564.7-1.564 1.564l-3.677 30.89c0 .863.7 1.564 1.563 1.564h46.245c.863 0 1.563-.7 1.563-1.564l-3.31-30.89c.001-.863-.698-1.564-1.562-1.564z",
    fill: "currentColor",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24.031a.59.59 0 0 0-.597-.583H24.345a.59.59 0 0 0-.596.583L23 29.864a.59.59 0 0 0 .596.584h10.807a.59.59 0 0 0 .597-.584v-5.833zM51.386 24.031a.59.59 0 0 0-.596-.583H40.597a.59.59 0 0 0-.597.583v5.833a.59.59 0 0 0 .597.584h10.806a.59.59 0 0 0 .597-.584l-.614-5.833zM53.174 36.114c0-.368-.312-.666-.696-.666H40.696c-.383 0-.696.298-.696.666v6.667c0 .367.313.666.697.666h12.606c.385 0 .697-.299.697-.666l-.826-6.667zM34 36.114a.657.657 0 0 0-.646-.666h-10.87a.657.657 0 0 0-.645.666L21 42.78c0 .367.29.666.646.666h11.707c.357 0 .646-.299.646-.666v-6.667H34z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56.528c0 .508-.34.92-.76.92H28.76c-.42 0-.76-.413-.76-.92v-2.161c0-.507.34-.92.76-.92h17.48c.42 0 .76.413.76.92v2.161z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50.447h-7v3h7v-3z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotovoltaics);
export default __webpack_public_path__ + "static/media/photovoltaics.9e2c9d2084be8304d0676cfdb016ff76.svg";
export { ForwardRef as ReactComponent };